import { defineMessages } from 'react-intl';

export const pageTitles = defineMessages({
    monitoring: {
        id: 'page-title-monitoring',
        defaultMessage: 'Monitoring',
    },
    vehicles: {
        id: 'page-title-vehicles',
        defaultMessage: 'Vehicles',
    },
    billing: {
        id: 'page-title-billing',
        defaultMessage: 'Billing',
    },
    statistics: {
        id: 'page-title-statistics',
        defaultMessage: 'Statistics',
    },
    users: {
        id: 'page-title-users',
        defaultMessage: 'User management',
    },
    parkings: {
        id: 'page-title-parkings',
        defaultMessage: 'Parking management',
    },
    profile: {
        id: 'page-title-profile',
        defaultMessage: 'My profile',
    },
    actions: {
        id: 'page-title-actions',
        defaultMessage: 'Actions',
    },
    home: {
        id: 'page-title-home',
        defaultMessage: 'Home',
    },
    smartPark: {
        id: 'page-title-smart-park',
        defaultMessage: 'SmartPark',
    },
    payStations: {
        id: 'page-title-pay-stations',
        defaultMessage: 'Pay stations',
    },
    validation: {
        id: 'page-title-validation',
        defaultMessage: 'Validation',
    },
    cashCollections: {
        id: 'cash-collections',
        defaultMessage: 'Cash collections',
    },
    parkingsAdmin: {
        id: 'page-title-parkings-admin',
        defaultMessage: 'Parking admin',
    },
    visitors: {
        id: 'page-title-visitors',
        defaultMessage: 'Visitors',
    },
    memberships: {
        id: 'page-title-memberships',
        defaultMessage: 'Memberships',
    },
    settings: {
        id: 'page-title-settings',
        defaultMessage: 'Settings',
    },
    entitiesCRM: {
        id: 'page-title-entities-crm',
        defaultMessage: 'CRM',
    },
    clients: {
        id: 'clients',
        defaultMessage: 'Clients',
    },
});
